"use server";

// ============================================================
// ANSICHTSSACHE-AGENT – Gastsitzung annehmen
// ============================================================
// Tauscht das Ticket, das eine Gastseite beim Zeichnen mitgibt,
// gegen die Sitzung (siehe `gast.ts`). Nur mit gültigem Ticket und
// nur von der eigenen Seite aus — dieselbe Vorsicht wie bei jeder
// Aktion ohne Anmeldung.
// ============================================================

import { cookies } from "next/headers";
import { isSameOrigin } from "@/lib/portal/shares";
import { GAST_BEREICHE, gastSitzungCookies, pruefeGastTicket, type GastBereich } from "./gast";

export async function gastSitzungAnnehmen(
  bereich: GastBereich,
  token: string,
  ticket: string,
): Promise<boolean> {
  if (!GAST_BEREICHE.includes(bereich)) return false;
  if (!(await isSameOrigin())) return false;
  if (!pruefeGastTicket(bereich, token, ticket)) return false;

  const cookieStore = await cookies();
  for (const cookie of gastSitzungCookies(bereich, token)) {
    cookieStore.set(cookie.name, cookie.value, cookie);
  }
  return true;
}
